"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import { NftPageStats } from "@/components/nft-attributes/NftStats";
import RememeImage from "@/components/nft-image/RememeImage";
import NFTMarketplaceLinks from "@/components/nft-marketplace-links/NFTMarketplaceLinks";
import Pagination from "@/components/pagination/Pagination";
import { printMemeReferences } from "@/components/rememes/RememePage";
import { RememeSort } from "@/components/rememes/Rememes";
import { publicEnv } from "@/config/env";
import { OPENSEA_STORE_FRONT_CONTRACT } from "@/constants/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import type { MemesExtendedData, NFT, Rememe } from "@/entities/INFT";
import { areEqualAddresses, formatAddress, numberWithCommas, printMintDate } from "@/helpers/Helpers";
import { getFileMimeTypeFromMetadata } from "@/helpers/nft.helpers";
import useCapacitor from "@/hooks/useCapacitor";
import { fetchUrl } from "@/services/6529api";
import { faFire, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { Col, Container, Dropdown, Row, Table } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import ArtistProfileHandle from "./ArtistProfileHandle";
import MemeCalendarPeriods from "./MemeCalendarPeriods";
import styles from "./TheMemes.module.scss";
const REMEMES_PAGE_SIZE = 20;
export function MemePageLiveRightMenu(props) {
  const $ = _c(134);
  const capacitor = useCapacitor();
  const {
    country
  } = useCookieConsent();
  let t0;
  bb0: {
    const id = props.nft?.id;
    if (!id) {
      t0 = "";
      break bb0;
    }
    if (props.nft?.has_distribution) {
      t0 = `/the-memes/${id}/distribution`;
      break bb0;
    }
    if (id > 3) {
      t0 = `https://github.com/6529-Collections/thememecards/tree/main/card${id}`;
      break bb0;
    }
    t0 = "https://github.com/6529-Collections/thememecards/tree/main/card1-3";
  }
  const distributionPlanLink = t0;
  const t1 = props.nft?.metadata;
  let t2;
  if ($[0] !== t1) {
    t2 = getFileMimeTypeFromMetadata(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const fileMimeType = t2;
  if (props.show && props.nft && props.nftMeta) {
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        span: 12
      };
      t4 = {
        span: 12
      };
      t5 = {
        span: 6
      };
      t6 = {
        span: 6
      };
      $[2] = t3;
      $[3] = t4;
      $[4] = t5;
      $[5] = t6;
    } else {
      t3 = $[2];
      t4 = $[3];
      t5 = $[4];
      t6 = $[5];
    }
    let t7;
    if ($[6] !== props.nft.id) {
      t7 = <Row><Col><MemeCalendarPeriods id={props.nft.id} /></Col></Row>;
      $[6] = props.nft.id;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Row className="pt-2"><Col><h3>Meme Collectors</h3></Col></Row>;
      $[8] = t8;
    } else {
      t8 = $[8];
    }
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <td>Edition Size</td>;
      $[9] = t9;
    } else {
      t9 = $[9];
    }
    let t10;
    if ($[10] !== props.nftMeta.edition_size) {
      t10 = numberWithCommas(props.nftMeta.edition_size);
      $[10] = props.nftMeta.edition_size;
      $[11] = t10;
    } else {
      t10 = $[11];
    }
    let t11;
    if ($[12] !== t10) {
      t11 = <td className="text-right tw-font-medium">{t10}</td>;
      $[12] = t10;
      $[13] = t11;
    } else {
      t11 = $[13];
    }
    let t12;
    if ($[14] !== props.nftMeta.collection_size || $[15] !== props.nftMeta.edition_size_rank) {
      t12 = <td className="text-right tw-font-medium">{props.nftMeta.edition_size_rank}/{props.nftMeta.collection_size}</td>;
      $[14] = props.nftMeta.collection_size;
      $[15] = props.nftMeta.edition_size_rank;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    let t13;
    if ($[17] !== t11 || $[18] !== t12) {
      t13 = <tr>{t9}{t11}{t12}</tr>;
      $[17] = t11;
      $[18] = t12;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    let t14;
    if ($[20] !== props.nftMeta.burnt || $[21] !== props.nftMeta.collection_size || $[22] !== props.nftMeta.edition_size_not_burnt || $[23] !== props.nftMeta.edition_size_not_burnt_rank) {
      t14 = props.nftMeta.burnt > 0 && <><tr><td><span className="d-flex align-items-center gap-2"><span>Burnt</span><FontAwesomeIcon icon={faFire} style={{
                height: "22px",
                color: "#c51d34"
              }} /></span></td><td className="text-right tw-font-medium">{numberWithCommas(props.nftMeta.burnt)}</td></tr><tr><td>Edition Size ex. Burnt</td><td className="text-right tw-font-medium">{numberWithCommas(props.nftMeta.edition_size_not_burnt)}</td><td className="text-right tw-font-medium">{props.nftMeta.edition_size_not_burnt_rank}/{props.nftMeta.collection_size}</td></tr></>;
      $[20] = props.nftMeta.burnt;
      $[21] = props.nftMeta.collection_size;
      $[22] = props.nftMeta.edition_size_not_burnt;
      $[23] = props.nftMeta.edition_size_not_burnt_rank;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    let t15;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <td>6529 Museum</td>;
      $[25] = t15;
    } else {
      t15 = $[25];
    }
    let t16;
    if ($[26] !== props.nftMeta.museum_holdings) {
      t16 = numberWithCommas(props.nftMeta.museum_holdings);
      $[26] = props.nftMeta.museum_holdings;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    let t17;
    if ($[28] !== t16) {
      t17 = <td className="text-right tw-font-medium">{t16}</td>;
      $[28] = t16;
      $[29] = t17;
    } else {
      t17 = $[29];
    }
    let t18;
    if ($[30] !== props.nftMeta.collection_size || $[31] !== props.nftMeta.museum_holdings_rank) {
      t18 = <td className="text-right tw-font-medium">{props.nftMeta.museum_holdings_rank}/{props.nftMeta.collection_size}</td>;
      $[30] = props.nftMeta.collection_size;
      $[31] = props.nftMeta.museum_holdings_rank;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    let t19;
    if ($[33] !== t17 || $[34] !== t18) {
      t19 = <tr>{t15}{t17}{t18}</tr>;
      $[33] = t17;
      $[34] = t18;
      $[35] = t19;
    } else {
      t19 = $[35];
    }
    const t20 = props.nftMeta.burnt > 0 && " Burnt and";
    let t21;
    if ($[36] !== t20) {
      t21 = <td>Edition Size ex.{t20}{" "}6529 Museum</td>;
      $[36] = t20;
      $[37] = t21;
    } else {
      t21 = $[37];
    }
    let t22;
    if ($[38] !== props.nftMeta.edition_size_cleaned) {
      t22 = numberWithCommas(props.nftMeta.edition_size_cleaned);
      $[38] = props.nftMeta.edition_size_cleaned;
      $[39] = t22;
    } else {
      t22 = $[39];
    }
    let t23;
    if ($[40] !== t22) {
      t23 = <td className="text-right tw-font-medium">{t22}</td>;
      $[40] = t22;
      $[41] = t23;
    } else {
      t23 = $[41];
    }
    let t24;
    if ($[42] !== props.nftMeta.collection_size || $[43] !== props.nftMeta.edition_size_cleaned_rank) {
      t24 = <td className="text-right tw-font-medium">{props.nftMeta.edition_size_cleaned_rank}/{props.nftMeta.collection_size}</td>;
      $[42] = props.nftMeta.collection_size;
      $[43] = props.nftMeta.edition_size_cleaned_rank;
      $[44] = t24;
    } else {
      t24 = $[44];
    }
    let t25;
    if ($[45] !== t21 || $[46] !== t23 || $[47] !== t24) {
      t25 = <tr>{t21}{t23}{t24}</tr>;
      $[45] = t21;
      $[46] = t23;
      $[47] = t24;
      $[48] = t25;
    } else {
      t25 = $[48];
    }
    let t26;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <td>Collectors</td>;
      $[49] = t26;
    } else {
      t26 = $[49];
    }
    let t27;
    if ($[50] !== props.nftMeta.hodlers) {
      t27 = numberWithCommas(props.nftMeta.hodlers);
      $[50] = props.nftMeta.hodlers;
      $[51] = t27;
    } else {
      t27 = $[51];
    }
    let t28;
    if ($[52] !== t27) {
      t28 = <td className="text-right tw-font-medium">{t27}</td>;
      $[52] = t27;
      $[53] = t28;
    } else {
      t28 = $[53];
    }
    let t29;
    if ($[54] !== props.nftMeta.collection_size || $[55] !== props.nftMeta.hodlers_rank) {
      t29 = <td className="text-right tw-font-medium">{props.nftMeta.hodlers_rank}/{props.nftMeta.collection_size}</td>;
      $[54] = props.nftMeta.collection_size;
      $[55] = props.nftMeta.hodlers_rank;
      $[56] = t29;
    } else {
      t29 = $[56];
    }
    let t30;
    if ($[57] !== t28 || $[58] !== t29) {
      t30 = <tr>{t26}{t28}{t29}</tr>;
      $[57] = t28;
      $[58] = t29;
      $[59] = t30;
    } else {
      t30 = $[59];
    }
    let t31;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t31 = <td>% Unique</td>;
      $[60] = t31;
    } else {
      t31 = $[60];
    }
    const t32 = Math.round(props.nftMeta.percent_unique * 100 * 10) / 10;
    let t33;
    if ($[61] !== t32) {
      t33 = <td className="text-right tw-font-medium">{t32}%</td>;
      $[61] = t32;
      $[62] = t33;
    } else {
      t33 = $[62];
    }
    let t34;
    if ($[63] !== props.nftMeta.collection_size || $[64] !== props.nftMeta.percent_unique_rank) {
      t34 = <td className="text-right tw-font-medium">{props.nftMeta.percent_unique_rank}/{props.nftMeta.collection_size}</td>;
      $[63] = props.nftMeta.collection_size;
      $[64] = props.nftMeta.percent_unique_rank;
      $[65] = t34;
    } else {
      t34 = $[65];
    }
    let t35;
    if ($[66] !== t33 || $[67] !== t34) {
      t35 = <tr>{t31}{t33}{t34}</tr>;
      $[66] = t33;
      $[67] = t34;
      $[68] = t35;
    } else {
      t35 = $[68];
    }
    let t36;
    if ($[69] !== props.nftMeta.burnt || $[70] !== props.nftMeta.collection_size || $[71] !== props.nftMeta.percent_unique_not_burnt || $[72] !== props.nftMeta.percent_unique_not_burnt_rank) {
      t36 = props.nftMeta.burnt > 0 && <tr><td>% Unique ex. Burnt</td><td className="text-right tw-font-medium">{Math.round(props.nftMeta.percent_unique_not_burnt * 100 * 10) / 10}%</td><td className="text-right tw-font-medium">{props.nftMeta.percent_unique_not_burnt_rank}/{props.nftMeta.collection_size}</td></tr>;
      $[69] = props.nftMeta.burnt;
      $[70] = props.nftMeta.collection_size;
      $[71] = props.nftMeta.percent_unique_not_burnt;
      $[72] = props.nftMeta.percent_unique_not_burnt_rank;
      $[73] = t36;
    } else {
      t36 = $[73];
    }
    const t37 = props.nftMeta.burnt > 0 && " Burnt and";
    let t38;
    if ($[74] !== t37) {
      t38 = <td>% Unique ex.{t37} 6529 Museum</td>;
      $[74] = t37;
      $[75] = t38;
    } else {
      t38 = $[75];
    }
    const t39 = Math.round(props.nftMeta.percent_unique_cleaned * 100 * 10) / 10;
    let t40;
    if ($[76] !== t39) {
      t40 = <td className="text-right tw-font-medium">{t39}%</td>;
      $[76] = t39;
      $[77] = t40;
    } else {
      t40 = $[77];
    }
    let t41;
    if ($[78] !== props.nftMeta.collection_size || $[79] !== props.nftMeta.percent_unique_cleaned_rank) {
      t41 = <td className="text-right tw-font-medium">{props.nftMeta.percent_unique_cleaned_rank}/{props.nftMeta.collection_size}</td>;
      $[78] = props.nftMeta.collection_size;
      $[79] = props.nftMeta.percent_unique_cleaned_rank;
      $[80] = t41;
    } else {
      t41 = $[80];
    }
    let t42;
    if ($[81] !== t38 || $[82] !== t40 || $[83] !== t41) {
      t42 = <tr>{t38}{t40}{t41}</tr>;
      $[81] = t38;
      $[82] = t40;
      $[83] = t41;
      $[84] = t42;
    } else {
      t42 = $[84];
    }
    let t43;
    if ($[85] !== t13 || $[86] !== t14 || $[87] !== t19 || $[88] !== t25 || $[89] !== t30 || $[90] !== t35 || $[91] !== t36 || $[92] !== t42) {
      t43 = <Row><Col><Table bordered={false} className={styles.hodlersTableLive}><tbody>{t13}{t14}{t19}{t25}{t30}{t35}{t36}{t42}</tbody></Table></Col></Row>;
      $[85] = t13;
      $[86] = t14;
      $[87] = t19;
      $[88] = t25;
      $[89] = t30;
      $[90] = t35;
      $[91] = t36;
      $[92] = t42;
      $[93] = t43;
    } else {
      t43 = $[93];
    }
    let t44;
    if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
      t44 = <Row className="pt-3"><Col><h3>NFT</h3></Col></Row>;
      $[94] = t44;
    } else {
      t44 = $[94];
    }
    let t45;
    if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
      t45 = <td>Artist Name</td>;
      $[95] = t45;
    } else {
      t45 = $[95];
    }
    let t46;
    if ($[96] !== props.nft.artist) {
      t46 = <tr>{t45}<td className="tw-font-medium">{props.nft.artist}</td></tr>;
      $[96] = props.nft.artist;
      $[97] = t46;
    } else {
      t46 = $[97];
    }
    let t47;
    if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
      t47 = <td>Artist Profile</td>;
      $[98] = t47;
    } else {
      t47 = $[98];
    }
    let t48;
    if ($[99] !== props.nft) {
      t48 = <tr>{t47}<td className="tw-font-medium"><ArtistProfileHandle nft={props.nft} /></td></tr>;
      $[99] = props.nft;
      $[100] = t48;
    } else {
      t48 = $[100];
    }
    let t49;
    if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
      t49 = <td>Mint Date</td>;
      $[101] = t49;
    } else {
      t49 = $[101];
    }
    let t50;
    if ($[102] !== props.nft.mint_date) {
      t50 = printMintDate(props.nft.mint_date);
      $[102] = props.nft.mint_date;
      $[103] = t50;
    } else {
      t50 = $[103];
    }
    let t51;
    if ($[104] !== t50) {
      t51 = <tr>{t49}<td className="tw-font-medium">{t50}</td></tr>;
      $[104] = t50;
      $[105] = t51;
    } else {
      t51 = $[105];
    }
    let t52;
    if ($[106] !== fileMimeType) {
      t52 = fileMimeType ? <tr><td>File Type</td><td><MediaTypeBadge mimeType={fileMimeType} size="sm" showTooltip={false} showLabel={true} tone="color" labelClassName="tw-text-inherit tw-font-medium" /></td></tr> : null;
      $[106] = fileMimeType;
      $[107] = t52;
    } else {
      t52 = $[107];
    }
    let t53;
    if ($[108] !== props.nft || $[109] !== t52) {
      t53 = <NftPageStats nft={props.nft} afterMetadata={t52} />;
      $[108] = props.nft;
      $[109] = t52;
      $[110] = t53;
    } else {
      t53 = $[110];
    }
    let t54;
    if ($[111] !== t46 || $[112] !== t48 || $[113] !== t51 || $[114] !== t53) {
      t54 = <Row><Col><Table bordered={false}><tbody>{t46}{t48}{t51}{t53}</tbody></Table></Col></Row>;
      $[111] = t46;
      $[112] = t48;
      $[113] = t51;
      $[114] = t53;
      $[115] = t54;
    } else {
      t54 = $[115];
    }
    let t55;
    if ($[116] !== distributionPlanLink || $[117] !== props.nft.has_distribution) {
      t55 = distributionPlanLink && <Row><Col><Link href={distributionPlanLink} target={props.nft.has_distribution ? "_self" : "_blank"} rel={props.nft.has_distribution ? undefined : "noopener noreferrer"}>Distribution Plan</Link></Col></Row>;
      $[116] = distributionPlanLink;
      $[117] = props.nft.has_distribution;
      $[118] = t55;
    } else {
      t55 = $[118];
    }
    let t56;
    if ($[119] !== props.nftBalance) {
      t56 = props.nftBalance > 0 && <Row className="pt-3"><Col><h3 className="font-color">You Own {props.nftBalance} edition{props.nftBalance > 1 && "s"}</h3></Col></Row>;
      $[119] = props.nftBalance;
      $[120] = t56;
    } else {
      t56 = $[120];
    }
    let t57;
    if ($[121] !== capacitor.isIos || $[122] !== country || $[123] !== props.nft.contract || $[124] !== props.nft.id) {
      t57 = (!capacitor.isIos || country === "US") && <Row className="pt-4"><Col><NFTMarketplaceLinks contract={props.nft.contract} id={props.nft.id} /></Col></Row>;
      $[121] = capacitor.isIos;
      $[122] = country;
      $[123] = props.nft.contract;
      $[124] = props.nft.id;
      $[125] = t57;
    } else {
      t57 = $[125];
    }
    let t58;
    if ($[126] !== t43 || $[127] !== t54 || $[128] !== t55 || $[129] !== t56 || $[130] !== t57 || $[131] !== t7) {
      t58 = <Col xs={t3} sm={t4} md={t5} lg={t6} className="pt-2"><Container className="p-0">{t7}{t8}{t43}{t44}{t54}{t55}{t56}{t57}</Container></Col>;
      $[126] = t43;
      $[127] = t54;
      $[128] = t55;
      $[129] = t56;
      $[130] = t57;
      $[131] = t7;
      $[132] = t58;
    } else {
      t58 = $[132];
    }
    return t58;
  } else {
    let t3;
    if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <></>;
      $[133] = t3;
    } else {
      t3 = $[133];
    }
    return t3;
  }
}
export function MemePageLiveSubMenu(props: {
  show: boolean;
  nft: NFT | undefined;
}) {
  const [memeLabNftsLoaded, setMemeLabNftsLoaded] = useState(false);
  const [memeLabNfts, setMemeLabNfts] = useState<NFT[]>([]);
  const [rememesTotalResults, setRememesTotalResults] = useState(0);
  const [rememesPage, setRememesPage] = useState(1);
  const [rememes, setRememes] = useState<Rememe[]>([]);
  const [showRememesSort, setShowRememesSort] = useState(false);
  const [rememesLoaded, setRememesLoaded] = useState(false);
  const rememesTarget = useRef<HTMLImageElement>(null);
  const rememeSorting = [RememeSort.RANDOM, RememeSort.CREATED_ASC];
  const [selectedRememeSorting, setSelectedRememeSorting] = useState<RememeSort>(RememeSort.RANDOM);
  useEffect(() => {
    if (props.nft) {
      fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts_memelab?sort_direction=asc&meme_id=${props.nft.id}`).then((response: DBResponse) => {
        setMemeLabNfts(response.data);
        setMemeLabNftsLoaded(true);
      });
    }
  }, [props.nft]);
  useEffect(() => {
    if (props.nft) {
      fetchRememes(props.nft.id);
    }
  }, [props.nft, rememesPage, selectedRememeSorting]);
  function fetchRememes(meme_id: number) {
    let sort = "";
    if (selectedRememeSorting === RememeSort.CREATED_ASC) {
      sort = "&sort=created_at&sort_direction=desc";
    }
    fetchUrl(`${publicEnv.API_ENDPOINT}/api/rememes?meme_id=${meme_id}&page_size=${REMEMES_PAGE_SIZE}&page=${rememesPage}${sort}`).then((response_0: DBResponse) => {
      setRememesTotalResults(response_0.count);
      setRememes(response_0.data);
      setShowRememesSort(response_0.count > REMEMES_PAGE_SIZE);
      setRememesLoaded(true);
    });
  }
  if (props.show) {
    return <>
        <Row className="pt-3">
          <Col>
            <Image unoptimized width="0" height="0" style={{
            width: "250px",
            height: "auto"
          }} src="/memelab.png" alt="memelab" />
          </Col>
        </Row>
        <Row className="pt-4 pb-2">
          <Col>
            The Meme Lab is the lab for Meme Artists to release work that is
            related to The Meme Cards.
          </Col>
        </Row>
        {printMemeReferences(memeLabNfts, "meme-lab", memeLabNftsLoaded, true)}
        <Row className="pt-3" ref={rememesTarget}>
          <Col className="d-flex flex-wrap align-items-center justify-content-between">
            <h1 className="mb-0 pt-2">
              <Image unoptimized width="0" height="0" style={{
              width: "250px",
              height: "auto",
              float: "left"
            }} src="/re-memes.png" alt="re-memes" />
            </h1>
            {showRememesSort && <span className="d-flex align-items-center gap-2 pt-2">
                <Dropdown className={styles["rememesSortDropdown"]} drop={"down-centered"}>
                  <Dropdown.Toggle>
                    Sort: {selectedRememeSorting}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {rememeSorting.map(s => <Dropdown.Item key={`sorting-${s}`} onClick={() => {
                  setRememesPage(1);
                  setRememesTotalResults(0);
                  setSelectedRememeSorting(s);
                }}>
                        {s}
                      </Dropdown.Item>)}
                  </Dropdown.Menu>
                </Dropdown>
                {selectedRememeSorting === RememeSort.RANDOM && <>
                    <FontAwesomeIcon icon={faRefresh} className={styles["buttonIcon"]} onClick={() => {
                if (props.nft) {
                  fetchRememes(props.nft.id);
                }
              }} data-tooltip-id="refresh-rememes" />
                    <Tooltip id="refresh-rememes" place="top" delayShow={250} style={{
                backgroundColor: "#f8f9fa",
                color: "#212529",
                padding: "4px 8px"
              }}>
                      Refresh results
                    </Tooltip>
                  </>}
              </span>}
          </Col>
        </Row>
        <Row className="pt-4 pb-2">
          <Col>
            ReMemes are community-created and community-submitted NFTs inspired
            by the Meme Cards. They are not created or &quot;authorized&quot; by
            6529 Collections.
          </Col>
        </Row>
        {rememesLoaded && rememes.length === 0 && <Row className="pt-2 pb-4">
            <Col>ReMemes that reference this NFT will appear here.</Col>
          </Row>}
        {rememes.length > 0 && <>
            <Row className="pt-2 pb-2">
              {rememes.map(rememe => {
            return <Col key={`${rememe.contract}-${rememe.id}`} className="pt-3 pb-3" xs={{
              span: 6
            }} sm={{
              span: 4
            }} md={{
              span: 3
            }} lg={{
              span: 3
            }}>
                    <Link href={`/rememes/${rememe.contract}/${rememe.id}`} className="decoration-none scale-hover">
                      <Container fluid className="no-padding">
                        <Row>
                          <Col>
                            <RememeImage nft={rememe} animation={false} height={300} />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Container>
                              <Row>
                                <Col className="font-smaller font-color-h d-flex justify-content-center align-items-center">
                                  {areEqualAddresses(rememe.contract, OPENSEA_STORE_FRONT_CONTRACT) ? <>
                                      {rememe.contract_opensea_data.collectionName}
                                    </> : <>
                                      {rememe.contract_opensea_data.collectionName ? rememe.contract_opensea_data.collectionName : formatAddress(rememe.contract)}{" "}
                                      #{rememe.id}
                                    </>}
                                  {rememe.replicas.length > 1 && <>
                                      &nbsp;(x
                                      {numberWithCommas(rememe.replicas.length)}
                                      )
                                    </>}
                                </Col>
                              </Row>
                              <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                  <span className="text-center">
                                    {rememe.metadata.name ? rememe.metadata.name : `${formatAddress(rememe.contract)} #${rememe.id}`}
                                  </span>
                                </Col>
                              </Row>
                            </Container>
                          </Col>
                        </Row>
                      </Container>
                    </Link>
                  </Col>;
          })}
            </Row>
            {rememesTotalResults > REMEMES_PAGE_SIZE && <Row className="text-center pt-2 pb-3">
                <Pagination page={rememesPage} pageSize={REMEMES_PAGE_SIZE} totalResults={rememesTotalResults} setPage={function (newPage: number) {
            setRememesPage(newPage);
            if (rememesTarget.current) {
              rememesTarget.current.scrollIntoView({
                behavior: "smooth"
              });
            }
          }} />
              </Row>}
          </>}
      </>;
  } else {
    return <></>;
  }
}